export default "__VITE_ASSET__3e7850c8__"